import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of'

@Injectable({
  providedIn: 'root'
})
export class BankAccountDataService {
  // selectedFip: any;
  userId: string;
  bankLogo: any;

  constructor(private http: HttpService) { }
  getBanksCard() {
    let option = {
      type: 'get',
      url: 'userconsent',
      includeUserSession: true
    }
    return this.http.makeHttpRequest(option);
  }

  getSelectedFip() {
    var selectedFip = localStorage.getItem('selectedLinkBank') || '[]';
    return JSON.parse(selectedFip);
  }

  setSelectedFip(fip) {
    localStorage.setItem('selectedLinkBank', JSON.stringify(fip));
  }

  discoverAccounts(option, callback?: any, fipId?: string) {
    this.http.makeHttpRequest(option).subscribe(res => {
      if (res != undefined) {
        this.setDiscoveredAccounts(res,fipId);
        callback();
      }
    });
  }

  linkDiscoveredAccounts(option, callback?: any) {
    console.log(option," checking option option option 123..")
    this.http.makeHttpRequest(option).subscribe(res => {
      if (res != undefined) {
        console.log(res," checking... link responce.....");
        this.setLinkedAccounts(res);
        callback();
      }
    });
  }

  setDiscoveredAccounts(accs,fId) {
    console.log(accs," acccssssss acccss")
    var obj = {
      discoveredAccounts:accs.data.DiscoveredAccounts,
      fip:fId
    }
    localStorage.setItem('discoveredAccs', JSON.stringify(obj));
  }

  setLinkRequestedAccounts(accs) {
    localStorage.setItem('linkRequestedAccs', JSON.stringify(accs));
  }

  setLinkedAccounts(accs) {
    localStorage.setItem('linkedAccs', JSON.stringify(accs));
  }

  getLinkingAccounts() {
    var discoveredAccountResponse = localStorage.getItem('discoveredAccs') || "[]";
    var discoveredAccounts = JSON.parse(discoveredAccountResponse);
    return discoveredAccounts;
  }

  getLinkedAccounts() {
    var discoveredAccountResponse = localStorage.getItem('linkedAccs') || "[]";
    var discoveredAccounts = JSON.parse(discoveredAccountResponse);
    return discoveredAccounts;
  }

  getLinkRequestedAccounts() {
    var linkRequestedAccs = localStorage.getItem('linkRequestedAccs') || "[]";
    linkRequestedAccs = JSON.parse(linkRequestedAccs);
    return linkRequestedAccs;
  }

  setuserId(userId) {
    this.userId = userId;
  }

  getuserId() {
    return this.userId;
  }

  accountlinkingconfirm(option, callback?: any) {
    this.http.makeHttpRequest(option).subscribe(res => {
      if (res != undefined) {
        callback(res);
      }
    });
  }

  getBanksLogos() {
    if (this.bankLogo == undefined || this.bankLogo == null) {
      let option = {
        type: "get",
        url: "banklogo",
        isLocal: true
      }
      this.bankLogo = this.http.makeHttpRequest(option);
      return this.bankLogo;
    } else {
      return this.bankLogo;
    }
  }

  removeLocalStorageItems() {
    var items = ['selectedLinkBank', 'discoveredAccs', 'linkedAccs', 'newUser', 'linkRequestedAccs']
    for (var i = 0; i < items.length; i++) {
      localStorage.removeItem(items[i]);
    }
  }
}
